import { render, staticRenderFns } from "./NewsManage.vue?vue&type=template&id=fc0129ba&scoped=true&"
import script from "./NewsManage.vue?vue&type=script&lang=js&"
export * from "./NewsManage.vue?vue&type=script&lang=js&"
import style0 from "./NewsManage.vue?vue&type=style&index=0&id=fc0129ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0129ba",
  null
  
)

export default component.exports